import Config from '@configs/Environments';
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { LoginCallback, Security } from "@okta/okta-react";
import { Loading as LoadingPage } from '@pages/Loading';
// import { Loading } from '@organisms/Feedbacks';
import { RequiredAuth, Routing } from '@pages/Routings';
import React, { useCallback } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

const callbackPath = '/login/callback';

const oktaAuth = new OktaAuth({
    issuer: Config.OKTA_ISSUER_URL,
    clientId: Config.OKTA_CLIENT_ID,
    redirectUri: `${window.location.origin}${callbackPath}`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
});

const SecureRouting = () => {
    const navigate = useNavigate();
    const restoreOriginalUri = useCallback(async (_oktaAuth: any, originalUri: any) => {
        navigate(toRelativeUrl(originalUri || '/', window.location.origin));
    }, [navigate]);

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <Routes>
                {/* {Routing.base.map(({ ...configs }, index: number) => <Route key={index} {...configs} />)} */}
                <Route path={callbackPath} element={<LoginCallback loadingElement={<LoadingPage />} />} />
                <Route path='' element={<RequiredAuth />}>
                    {Routing.content.map(({ ...configs }, index: number) => <Route key={index} {...configs} />)}
                    {/* {Routing.secure.map(({ ...configs }, index: number) => <Route key={index} {...configs} />)} */}
                </Route>
            </Routes>
        </Security>
    );
}

export default SecureRouting;